import { zeusTokens } from '@pancakeswap/tokens'
import { getAddress } from 'viem'

import { PoolCategory, SerializedPool } from '../../types'

export const livePools: SerializedPool[] = [
  {
    sousId: 1,
    stakingToken: zeusTokens.zinu,
    earningToken: zeusTokens.zeusGold,
    contractAddress: '0x29487a3f6ae3ac6e37cf97feae0c5f8d2b111cff',
    poolCategory: PoolCategory.CORE,
    tokenPerBlock: '0.1',
    isFinished: false,
  }
  // },
  // {
  //   sousId: 2,
  //   stakingToken: zeusTokens.zinu,
  //   earningToken: zeusTokens.zeusGold,
  //   contractAddress: '0x060ff17efa854677202b6a7ac1ebdb98deff9a1c',
  //   poolCategory: PoolCategory.CORE,
  //   tokenPerBlock: '1',
  //   isFinished: false,
  // }
].map((p) => ({
  ...p,
  contractAddress: getAddress(p.contractAddress),
  stakingToken: p.stakingToken.serialize,
  earningToken: p.earningToken.serialize,
}))




  

export const pools: SerializedPool[] = [...livePools]
